
import React from 'react';
import FormModal from "../form-modal/FormModal";
import {Button, CircularProgress, ThemeProvider} from "@mui/material";
import {THEME} from "../../theme/PacsTheme";

import FileImage from "../../images/file-icon.svg";

import "./FileUploadModal.css";
import {isNull} from "../../util/Validators";
import {net_uploadFile} from "../../net/FileUploadCalls";

export default function FileUploadModal(props) {

    const MAX_SIZE = 1024*1024*10;

    const [uploading, setUploading] = React.useState(false);
    const [open, setOpen] = React.useState(props.open);
    const [file, setFile] = React.useState(null);

    const handleClick = () => {
        document.getElementById("file").click();
    }

    const handleChange = (obj) => {
        setFile(obj.target.files[0]);
    }

    const handleClose = () => {
        setOpen(false);
        props.setOpen(false);
    }

    const handleUpload = () => {

        if (file.size < MAX_SIZE) {

            const formData = new FormData();

            setUploading(true);

            formData.append("file", file);
            formData.append("id", props.id);

            net_uploadFile(formData, (response) => {
                if (response.code === 200) {
                    setOpen(false);
                    props.onUpload(file);
                }
            }, error => {
                console.warn(error.message);
            })
        } else {
            alert("Maximum file size exceeded.  10MB Maximum");
            setFile(null);
        }
    }

    const fileUpload =  <div>
                                    <div
                                        style={{
                                            marginBottom: "20px"
                                        }}
                                        className={"default-text-align-center default-font-color-dark"}>
                                        Click To Upload File
                                    </div>
                                    <div style={{
                                        width: "100px",
                                        height: "100px",
                                        margin: "auto",
                                    }}>
                                        <img
                                            src={FileImage}
                                            alt={"File Upload"}
                                            width={"100%"}
                                            height={"100%"}
                                            onClick={handleClick}
                                            className={"file-upload-icon"}
                                        />
                                    </div>
                                    <div style={{
                                        textAlign: "center",
                                        marginTop: "30px"
                                    }}>
                                        <ThemeProvider theme={THEME}>
                                            <Button
                                                variant={"contained"}
                                                style={{
                                                    width: "90px",
                                                    height: "40px",
                                                    marginRight: "10px"
                                                }}
                                                onClick={handleClose}
                                            >
                                                <span>CANCEL</span>
                                            </Button>
                                            <Button
                                                variant={"contained"}
                                                style={{
                                                    width: "90px",
                                                    height: "40px",
                                                    marginLeft: "10px"
                                                }}
                                                disabled={isNull(file) || uploading}
                                                onClick={handleUpload}
                                            >
                                                <span>{uploading ?
                                                    <CircularProgress size={"20px"} style={{
                                                        position: "relative",
                                                        top: "5px"
                                                    }} />

                                                    : "UPLOAD"}</span>
                                            </Button>
                                        </ThemeProvider>
                                    </div>
                                </div>


    return <React.Fragment>

        <FormModal
            key={"fm_"+Date.now()}
            titleText={"File Upload"}
            width={300}
            height={250}
            open={open}
            content={fileUpload}
        />

        <input
            style={{
                visibility: "hidden",
            }}

            id="file"
            type="file"
            name="file"
            onChange={handleChange}
        />

    </React.Fragment>

}